// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"93":"list","177":"home","180":"story"}[chunkId] || chunkId) + "-" + {"93":"51e32f6060276e8b1ad7","177":"0f9b1cd8a0c1b0aa6ab1","180":"5a78e71e498ffbfe9220","994":"c860bc3517f0f83fc40c"}[chunkId] + ".css";
};